import { render } from "./importTemplate.vue?vue&type=template&id=d7827c8e"
import script from "./importTemplate.vue?vue&type=script&lang=js"
export * from "./importTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__